import { connect } from 'react-redux';
import ParameterBK from '../../views/Settings/ParameterBK.view';
import {
  getUserGroups, getSchoolUnitsOptions, getParamPerwakilan,
  getPrmStaffKepsek, getParamOptionsAcademics
} from '../../states/thunks/options.thunk';
import { listBlockUnits, editParameterBK, saveParameterBK, listParameterBK } from '../../states/thunks/academics.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleListBlockUnits: (payload, goback) => dispatch(listBlockUnits(payload, goback)),
    getPrmStaffKepsekOptions: payload => dispatch(getPrmStaffKepsek(payload)),
    getUserGroups: payload => dispatch(getUserGroups(payload)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    getParamPerwakilan: payload => dispatch(getParamPerwakilan(payload)),
    handleListParameterBK: (payload, goback) => dispatch(listParameterBK(payload, goback)),
    handleSaveParameterBK: (payload, goback) => dispatch(saveParameterBK(payload, goback)),
    handleEditParameterBK: (payload, goback) => dispatch(editParameterBK(payload, goback)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ParameterBK);
